// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useEffect, useRef, useState} from 'react';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import etask from 'zetask';

/* eslint-disable */
export enum IP_ERROR_CODES {
    USED = 'used',
    INVALID = 'invalid',
}
/* eslint-enable */

type t_ip_v4 = [string, string, string, string];

const empty_ip: t_ip_v4 = ['', '', '', ''];

const segment_re = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{0,2})$/;

const validate_segment = (v: string)=>{
    return segment_re.test(v);
};

const use_ip_address = ()=>{
    const state = useRef({segments: empty_ip});
    const [segments, set_segments] = useState<t_ip_v4>(empty_ip);
    const set_segment = (i, v)=>{
        if (!validate_segment(v))
            return;
        set_segments(current=>{
            const _new: t_ip_v4 = [...current];
            _new.splice(i, 1, v);
            state.current.segments = _new;
            return _new;
        });
    };
    const validate = ()=>{
        return state.current.segments.every(v=>!!v && validate_segment(v));
    };
    const reset = (v?: t_ip_v4)=>{
        const _new = v||empty_ip;
        state.current.segments = _new;
        set_segments(_new);
    };
    const paste = (text: string)=>{
        const values = text.trim().split('.').slice(0, 4)
            .map(s=>validate_segment(s) ? s : '');
        const ip_segments = empty_ip.map((v, i)=>values[i]||v) as t_ip_v4;
        reset(ip_segments);
    };
    return {
        segments,
        value: segments.join('.'),
        set_segment,
        validate,
        validate_segment,
        reset,
        paste,
    };
};

export const get_myip = ()=>etask(function*(){
    try {
        const res = yield fetch('/myip');
        return res;
    } catch(e){ console.log(e); }
});

interface i_use_ip_list_props {
    initial_data: string[];
    on_add_ip: (ip: string, ips: string[])=>etask_t;
    on_remove_ip: (ip: string, ips: string[])=>etask_t;
}

export const use_ip_list = (props: i_use_ip_list_props)=>{
    const {initial_data = [], on_add_ip, on_remove_ip} = props;
    const ip = use_ip_address();
    const [error, set_error] = useState<IP_ERROR_CODES>();
    const [list, set_list] = useState<string[]>(initial_data);
    useEffect(()=>{
        set_error(null);
    }, [ip.segments]);
    const validate_ip = ()=>{
        if (list.some(item=>ip.value===item))
            return IP_ERROR_CODES.USED;
        if (!ip.validate())
            return IP_ERROR_CODES.INVALID;
    };
    const add_ip = ()=>etask(function*(){
        const err = validate_ip();
        if (err)
            return void set_error(err);
        set_error(null);
        const new_list = [...list, ip.value];
        const res = yield on_add_ip(ip.value, new_list);
        if (res)
            set_list(new_list);
    });
    const paste_ip = (v: string)=>{
        if (!v)
            return void set_error(IP_ERROR_CODES.INVALID);
        ip.paste(v);
        if (!ip.validate())
        {
            set_error(IP_ERROR_CODES.INVALID);
            return void ip.reset();
        }
    };
    const remove_ip = (v: string)=>etask(function*(){
        set_error(null);
        const new_list = list.filter(item=>item!=v);
        const res = yield on_remove_ip(v, new_list);
        if (res)
            set_list(new_list);
    });
    return {
        ip,
        list,
        error,
        validate_ip,
        add_ip,
        paste_ip,
        remove_ip,
    };
};
